import { Navigate, useSearchParams } from 'react-router-dom';
import { BrandDescription } from '../BrandDescription';
import { MARCA_NUEVA } from '../../lib/onboardingMarca/marcaNueva';

/**
 * La ruta de siempre de "Añadir nueva marca" (`/redes-sociales/descripcion-brand?mode=additional`,
 * adonde llevan los 5 botones). Con el onboarding de marca prendido, la marca nueva se suma con
 * sus pantallas (ADR-2026-10-02-marca-nueva-como-el-onboarding); el resto sigue en la pantalla vieja.
 */
export function DescripcionDeMarcaONueva({ conOnboardingDeMarca }: { conOnboardingDeMarca: boolean }) {
  const [params] = useSearchParams();
  if (conOnboardingDeMarca && params.get('mode') === 'additional') return <Navigate to={MARCA_NUEVA.link} replace />;
  return <BrandDescription />;
}

export default DescripcionDeMarcaONueva;
